declare const jQuery: any;
const $ = jQuery;

import { onLargeScreen } from "./breakpoint-detect";

let mainHeaderSelector: string = ".main-header";

export function getScrollToOffset(padding: number = 0): number
{
	const $header = $(mainHeaderSelector);
	if ($header.length > 0 && $header.css("position") === "fixed")
	{
		return -($header.outerHeight() + padding);
	}
	return 0;
}

getScrollToOffset.setMainHeaderSelector = function setMainHeaderSelector(selector: string): void {
	mainHeaderSelector = selector;
};

if (!window["iw"])
{
	window["iw"] = {};
}

window["iw"].getScrollToOffset = getScrollToOffset;
